export const BOOK_APPOINTMENT_CLICKED = 'book.appointment.clicked';
export const GET_DIRECTIONS_CLICKED = 'get.directions.clicked';
export const SEARCH_ADDRESS_SUBMITTED = 'search.address.submited';
export const STORE_DETAILS_CLICKED = 'store.detail.clicked';
export const STORE_INFO_CLICKED = 'store.info.clicked';
export const STORE_MARKER_CLICKED = 'store.marker.clicked';
export const STORE_PHONE_CLICKED = 'store.phone.clicked';

export interface IStoreData {
    storeId?: string;
    storeName?: string | undefined;
}

export interface ISearchAddress {
    address?: string | undefined;
}

export type ServiceStoresEvents = {
    [BOOK_APPOINTMENT_CLICKED]: IStoreData | void;
    [GET_DIRECTIONS_CLICKED]: IStoreData | void;
    [SEARCH_ADDRESS_SUBMITTED]: ISearchAddress;
    [STORE_DETAILS_CLICKED]: IStoreData | void;
    [STORE_INFO_CLICKED]: IStoreData | void;
    [STORE_MARKER_CLICKED]: IStoreData | void;
    [STORE_PHONE_CLICKED]: IStoreData | void;
};
